/**
 * A value that lags behind, so a search box does not fire a request per keystroke.
 */
import { useEffect, useState } from 'react';

/**
 * Returns `value` as it was `delayMs` ago, once it has stopped changing.
 *
 * Feed the debounced value to `useAsync`'s dependency list and the live one to
 * the text field, so typing stays instant while the request waits.
 */
export function useDebounced<T>(value: T, delayMs = 300): T {
  const [settled, setSettled] = useState(value);

  useEffect(() => {
    const timer = setTimeout(() => setSettled(value), delayMs);
    return () => clearTimeout(timer);
  }, [value, delayMs]);

  return settled;
}
